module.exports = {
  customClassName: '',
  withButtons: null,
  multiline: false,
  setInputActive: () => false
};
